export default [

     {
          path: '/physical-course-request',
          name: 'PhysicalCourseRequest',
          component: () => import("@/views/Page/PhysicalCourseRequest/PhysicalCourseRequest.vue"),
           meta: {
               title: 'GRC | PhysicalCourseRequest',
          },
     }
];